// src/components/SPanel/Home/homeHooks.js
//
// Bucăți comune ale widget-urilor: cifre care cresc animat, „a apărut” (barele
// și inelele pornesc de la 0 și se umplu) și mărimea unui element (graficele
// se desenează la pixel, pe mărimea widget-ului).

import { useEffect, useLayoutEffect, useRef, useState } from "react";

import { prefersReducedMotion } from "../../../utils/appearanceSettings";

const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

/** Cifra crește de la valoarea de dinainte (prima dată de la 0) la cea nouă. */
export function useCountUp(target, duration = 1000) {
   const to = Number(target) || 0;
   const [value, setValue] = useState(() => (prefersReducedMotion() ? to : 0));
   const fromRef = useRef(value);

   useEffect(() => {
      if (prefersReducedMotion()) {
         fromRef.current = to;
         setValue(to);
         return undefined;
      }
      const from = fromRef.current;
      const startedAt = performance.now();
      let raf = 0;
      const step = (now) => {
         const t = Math.min(1, (now - startedAt) / duration);
         const next = from + (to - from) * easeOutCubic(t);
         fromRef.current = next;
         setValue(next);
         if (t < 1) raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
      return () => cancelAnimationFrame(raf);
   }, [to, duration]);

   return Math.round(value);
}

/** true puțin după montare: barele și inelele pornesc de la 0 și se umplu. */
export function useAppeared(delay = 120) {
   const [appeared, setAppeared] = useState(false);
   useEffect(() => {
      const timer = window.setTimeout(() => setAppeared(true), delay);
      return () => window.clearTimeout(timer);
   }, [delay]);
   return appeared;
}

/** Lățimea și înălțimea unui element, urmărite cât timp e pe ecran. */
export function useElementSize() {
   const ref = useRef(null);
   const [size, setSize] = useState({ width: 0, height: 0 });
   useLayoutEffect(() => {
      const node = ref.current;
      if (!node || typeof ResizeObserver === "undefined") return undefined;
      const observer = new ResizeObserver(([entry]) => {
         const width = Math.round(entry.contentRect.width);
         const height = Math.round(entry.contentRect.height);
         setSize((prev) =>
            prev.width === width && prev.height === height ? prev : { width, height },
         );
      });
      observer.observe(node);
      return () => observer.disconnect();
   }, []);
   return [ref, size];
}
